import { GreyTag } from "@cleanup/components/TagMore";
import { translate } from "@/hooks/useLanguage";
import { LanguageKey } from "@/types/generated/LanguageKey";

const ExcludeLabel: React.FC = () => {

  return <GreyTag size={"sm"}>{translate(LanguageKey.exclude_upper_key)}</GreyTag>;
};

export default ExcludeLabel;
